import(/* webpackMode: "eager" */ "/tmp/build/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/build/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/tmp/build/node_modules/react-fast-marquee/dist/index.js");
;
import(/* webpackMode: "eager" */ "/tmp/build/src/app/(marketing)/integrations/icons/wordpress-tile.svg");
;
import(/* webpackMode: "eager", webpackExports: ["ChatBubbleExample"] */ "/tmp/build/src/components/marketing/ChatBubbleExample.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build/src/components/marketing/Faq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturesGrid"] */ "/tmp/build/src/components/marketing/FeaturesGrid.tsx");
